/*
 * Copyright 2015-2020 reserved by jufeng.com.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
'use strict';

var LOG = require('logger').getLogger('jufeng.info');

var $ = window.jQuery = require('base');

require('../common/com.jufeng.common.header');

//载入默认页内容
var target = $('.j-hidden-target').val();
$(".page_box").load("/footer_link1/" + target + ".html");

$(".external_link").click(function(){
	$(".page_box").load(this.href);
	return false;
});

//样式
require('../css/bootstrap.css');
require('../css/font/fonts.css');
require('../css/cat_nav.less');
require('../css/style2.css');
require('../css/common.css');
require('../css/header.less');
require('../css/footer.css');
require('../css/floor_right.less');
require('../css/news.css');
require('../css/activity.less');



// WEBPACK FOOTER //
// ./src/main/javascript/info/com.jufeng.info.js